<template>
  <main-right title="修改手机号">
    <SmsCountDown v-if="step < 3" :step.sync="step"></SmsCountDown>
    <StepBar class="step_bar" :step="step"></StepBar>
    <LoginForm
      class="base_form"
      v-if="step === 1"
      baseForm
      disabledPhone
      phonePlaceholder="当前绑定手机号"
      remember
      :formType="3"
      v-model="formOld"
      @smsSended="smsIsSend">
      <ad-button :disabled="disableFirst" @click="checkOldPhone">下一步</ad-button>
    </LoginForm>
    <LoginForm
      class="base_form"
      v-else-if="step === 2"
      baseForm
      phonePlaceholder="新手机号"
      :formType="3"
      v-model="formNew">
      <ad-button :disabled="disableSecond" @click="bindNewPhone">下一步</ad-button>
    </LoginForm>
    <div class="modify_success" v-else>
      <div>
        <img class="suc_icon" :src="sucImage">
        <span class="suc_tip">恭喜，手机号修改成功！</span>
      </div>
      <ad-button :disabled="false" @click="goLogin">完成</ad-button>
    </div>
  </main-right>
</template>

<script type="text/javascript">
import moment from 'moment'
import StepBar from '@/components/ThePasswordStepBar'
import LoginForm from '@/views/Registry/childrens/LoginForm'
import SmsCountDown from './component/SmsCountdonw'
import sucImage from '@/assets/success_image.png'
import { updateToken, modifyPhone } from '@/utils/customerApi'

export default {
  name: 'ModifyPhone',
  components: { SmsCountDown, StepBar, LoginForm },
  data () {
    return {
      formOld: {
        phoneNumber: '',
        smsVerifyCode: '',
      },
      formNew: {
        phoneNumber: '',
        smsVerifyCode: ''
      },
      step: 1,
      updateToken: '',
      sucImage
    }
  },
  computed: {
    disableFirst () {
      return !(this.formOld.phoneNumber && this.formOld.smsVerifyCode)
    },
    disableSecond () {
      return !(this.formNew.phoneNumber && this.formNew.smsVerifyCode)
    }
  },
  watch: {
    '$store.state.customer.userInfo.phone': {
      immediate: true,
      handler (v) {
        this.$nextTick(() => {
          this.formOld.phoneNumber = v
        })
      }
    },
    step (n, o) {
      if (n === 1 && o === 2) { // 300s倒计时结束由第二步跳回第一步
        this.formOld.smsVerifyCode = ''
        this.formNew = { phoneNumber: '', smsVerifyCode: '' }
      }
    }
  },
  methods: {
    smsIsSend () {
      // sessionStorage.setItem('$smsTime', moment().valueOf())
    },
    async checkOldPhone () { // 原手机号校验(获取老手机的修改令牌)
      const userId = this.$store.state.customer.userInfo.id
      if (!userId) {
        console.log('%c 用户ID不存在', 'background:#999;color:#FFFF00;padding:2px 6px 2px 0')
        return
      }
      const res = await updateToken(userId, {
        phone: this.formOld.phoneNumber,
        smsVerifyCode: this.encode(this.formOld.smsVerifyCode)
      })
      if (res && res.code === 0 && res.data) {
        sessionStorage.setItem('$smsTime', moment().valueOf())
        this.updateToken = res.data
        this.step += 1
      } else {
        tzx_czcPush('account', 'changePhoneFail', this.step)
      }
    },
    async bindNewPhone () { // 绑定新手机
      if (!this.updateToken) {
        console.warn('无效的手机令牌')
        return
      }
      const res = await modifyPhone({
        loginToken: localStorage.getItem('user_ticket'),
        updateToken: this.updateToken,
        phoneNumber: this.formNew.phoneNumber,
        smsVerifyCode: this.encode(this.formNew.smsVerifyCode)
      })
      if (res && res.code === 0) {
        this.messageTip('手机号修改成功', 1)
        this.step += 1
        const t = setTimeout(() => {
          clearTimeout(t)
          this.goLogin()
        }, 3500)
        tzx_czcPush('account', 'changePhoneSuccess')
      } else {
        tzx_czcPush('account', 'changePhoneFail', this.step)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step_bar {
  margin-top: 60px;
}
.base_form {
  width: 360px;
  margin: 60px auto 0;
}
.modify_success {
  margin: 40px auto;
  text-align: center;
  .suc_icon {
    width: 185px;
  }
  .suc_tip {
    display: block;
    color: #282729;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 10px 0 40px;
  }
}
</style>